const STORAGE_KEY = 'mindtype_progress';

export interface SavedProgress {
  personalInfo: {
    gender: string;
    ageGroup: string;
    currentStatus: string;
    industryField: string;
  } | null;
  answers: Array<{ questionId: string; selected: 'A' | 'B' | string; timestamp: number }>;
  currentIndex: number;
  startTime: number;
  lastUpdated: number;
}

// 保存进度
export function saveProgress(progress: SavedProgress): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({
      ...progress,
      lastUpdated: Date.now(),
    }));
  } catch (error) {
    console.error('Failed to save progress:', error);
  }
}

// 读取进度
export function loadProgress(): SavedProgress | null {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (!saved) return null;

    const progress = JSON.parse(saved) as SavedProgress;

    // 检查是否过期（7天）
    const sevenDays = 7 * 24 * 60 * 60 * 1000;
    if (Date.now() - progress.lastUpdated > sevenDays) {
      clearProgress();
      return null;
    }

    return progress;
  } catch (error) {
    console.error('Failed to load progress:', error);
    return null;
  }
}

// 清除进度
export function clearProgress(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.error('Failed to clear progress:', error);
  }
}

// 检查是否有保存的进度
export function hasProgress(): boolean {
  return loadProgress() !== null;
}
